import {Modal} from '@ui/molecules/modal';
import {ModalCard} from '@ui/layouts/modal-card';
import {BackAction} from '@ui/molecules/back-action';
import {CancelIcon} from '@ui/atoms/icons';
import {Button} from '@ui/atoms/button';
import {Body2, Headline2} from '@ui/atoms/typography';

interface CycleEditConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  cycleStatus: 'active' | 'paused';
  zIndex?: number;
}

export const CycleEditConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  cycleStatus,
  zIndex,
}: CycleEditConfirmationModalProps) => {
  const getModalContent = () => {
    if (cycleStatus === 'active') {
      return {
        title: 'Active Check-in Detected',
        description:
          'This action will close the current check-in immediately (existing answers will be archived).',
        instruction: 'Click "confirm" to continue.',
        buttonText: 'Confirm',
      };
    }
    return {
      title: "Check-in's Paused",
      description:
        'Changes will take effect immediately when you resume cycle.',
      instruction: 'Click "save" to continue.',
      buttonText: 'Save',
    };
  };

  const content = getModalContent();

  if (!isOpen) return null;

  return (
    <Modal open onClose={onClose} zIndex={zIndex}>
      <div style={{maxWidth: '500px', margin: 'auto'}}>
        <div className="flex justify-end mb-3">
          <BackAction
            icon={<CancelIcon />}
            title="Close"
            type="button"
            onClick={onClose}
            width="md"
          />
        </div>
        <ModalCard title="">
          <div style={{padding: '60px 30px'}}>
            <Headline2 align="center">{content.title}</Headline2>
            <div className="mt-4 mb-2 text-center">
              <Body2 kind="textBody">{content.description}</Body2>
            </div>
            <div className="mb-6 text-center">
              <Body2 kind="textBody">{content.instruction}</Body2>
            </div>
            <Button
              width="full"
              onClick={onConfirm}
              isLoading={isLoading}
              disabled={isLoading}>
              {content.buttonText}
            </Button>
          </div>
        </ModalCard>
      </div>
    </Modal>
  );
};
